<template>
    <div class="flex p-2 bg-white grid grid-cols-[auto_1fr_auto] rounded-lg border border-gray-200">
        <div>
            <img :src="vehicle_primary_image_url || '/vehicle-placeholder.jpg'" alt="" class="h-48 w-72 rounded-md object-cover" />
        </div>

        <div class="ml-4 flex flex-1 flex-col justify-between sm:ml-6">
            <div class="relative pr-0">
                <div>
                    <div class="flex justify-between">
                        <h3 v-if="vehicle_vrm || lot_number" class="text-sm">
                            <span v-if="lot_number" class="font-medium text-gray-700">{{ `Lot: ${lot_number} ` }}</span>
                            <span v-if="vehicle_vrm" class="font-medium text-gray-700">{{ lot_number ? `(${vehicle_vrm})` : vehicle_vrm }}</span>
                        </h3>
                    </div>
                    <div class="mt-1 flex text-sm mb-4">
                        <p class="text-gray-500">{{ `${vehicle_make} ${vehicle_model}` }}</p>
                        <p class="ml-4 border-l border-gray-200 pl-4 text-gray-500">{{ vehicle_colour }}</p>
                    </div>
                    <p v-if="asset_sale_price_net" class="mt-1 text-xs font-medium text-gray-900">
                        <span class="text-gray-500">Sale Price NET: </span>
                        <span class="text-gray-900">{{ monetise(asset_sale_price_net) }}</span>
                    </p>
                    <p v-if="seller_account_name" class="mt-1 text-xs font-medium text-gray-900">
                        <span class="text-gray-500">Seller: </span>
                        <span class="text-gray-900">{{ seller_account_name }} <span v-if="seller_account_code">({{ seller_account_code }})</span></span>
                    </p>
                    <p v-if="buyer_account_name" class="mt-1 text-xs font-medium text-gray-900">
                        <span class="text-gray-500">Buyer: </span>
                        <span class="text-gray-900">{{ buyer_account_name }} <span v-if="buyer_account_code">({{ buyer_account_code }})</span></span>
                    </p>
                </div>
            </div>

            <p v-if="vehicle_finance_eligible" class="mt-4 flex space-x-2 text-sm text-gray-700">
                    <AlertWarningIcon class="h-5 w-5 shrink-0 text-red-600" v-if="!vehicle_finance_eligible.eligible" />
                    <AlertSuccessIcon class="h-5 w-5 shrink-0 text-green-600" v-else />
                    <span>{{ vehicle_finance_eligible.message }}</span>
            </p>
        </div>

        <div>
            <button v-if="remove_enabled" v-on:click="() => removeVehicle()" type="button" class="p-1 flex items-center justify-center text-gray-400 hover:text-red-500 cursor-pointer transition">
                <TrashIconFill class="w-5 h-5" />
            </button>
        </div>
    </div>
</template>

<script>
import  { monetise } from '@lib/helpers'

import AlertSuccessIcon from "@ico/AlertSuccessIcon.vue"
import AlertWarningIcon from "@ico/AlertWarningIcon.vue"
import TrashIconFill from "@ico/TrashIconFill.vue"

export default {
    components: {
        AlertSuccessIcon,
        AlertWarningIcon,
        TrashIconFill
    },
    props: [
        'vehicle_vrm',
        'vehicle_make',
        'vehicle_model',
        'vehicle_colour',
        'vehicle_primary_image_url',
        'asset_sale_price_net',
        'seller_account_name',
        'seller_account_id',
        'seller_account_code',
        'buyer_account_id',
        'buyer_account_name',
        'buyer_account_code',
        'lot_number',
        'vehicle_finance_eligible',
        'remove_enabled'
    ],
    setup(props, { emit }) {

        const removeVehicle = () => {
            emit('remove_vehicle')
        }

        return {
            monetise,
            removeVehicle
        }
    },
}
</script>